import React from 'react';
import { APP_ENVIRONMENT } from '@/constants';
import NavButtons from './NavButtons';

const FloatingButtons = props => {
  const {
    isAvailableNavigation,
    paginationPageNum,
    paginationPagesTotal,
    paginationPageSize,
    paginationItemsTotal,
    paginationToPrevPage,
    paginationToNextPage,
    paginationGoToPage,
  } = props;

  switch (process.env.REACT_APP_TARGET) {
    case APP_ENVIRONMENT.CLIPX_WEB:
    case APP_ENVIRONMENT.WEB_COMPONENT: {
      return (
        <>
          {isAvailableNavigation && (
            <NavButtons
              paginationPageNum={paginationPageNum}
              paginationPagesTotal={paginationPagesTotal}
              paginationPageSize={paginationPageSize}
              paginationItemsTotal={paginationItemsTotal}
              paginationToPrevPage={paginationToPrevPage}
              paginationToNextPage={paginationToNextPage}
              paginationGoToPage={paginationGoToPage}
            />
          )}
        </>
      );
    }
    default: {
      return null;
    }
  }
};

export default React.memo(FloatingButtons);
